exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.animal-checkbox-div {\n  display: flex;\n  height: 40px;\n  justify-content: center; }\n\ndiv.animal-checkbox-div-wrapper {\n  margin-top: 10px; }\n\ndiv.client-form {\n  margin-top: 0; }\n\ndiv.sitter-form {\n  margin-top: 0; }\n\ninput.account-radio {\n  margin: 10px; }\n\ninput.animal-checkbox {\n  margin: 10px; }\n\nlabel {\n  margin: 10px; }\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 5vh auto;\n  max-width: 600px; }\n  .auth-form h3,\n  .auth-form input,\n  .auth-form textarea {\n    margin-bottom: 5%; }\n  .auth-form button {\n    align-self: flex-end;\n    max-width: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/auth/auth.scss
// module id = 292
// module chunks = 0